import React, { FC, ReactNode } from "react";

const PageTransparent: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="pages-transparent">{children}</div>;
};

export default PageTransparent;
